import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];

  editExercise(event) {
    const exerciseId = event.currentTarget.dataset.exerciseId;
    const courseId = event.currentTarget.dataset.courseId;
    const lessonId = event.currentTarget.dataset.lessonId;
    const exerciseEl = document.getElementById(`exercise_${exerciseId}`);
    if (!exerciseEl) return;

    const url = event.currentTarget.dataset.editUrl ||
      `/teacher/courses/${courseId}/lessons/${lessonId}/exercises/${exerciseId}/edit`;
    fetch(url, {
      headers: {
        "Accept": "text/html",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then(response => response.text())
      .then(html => {
        exerciseEl.innerHTML = html;
        this.#initRhinoEditor(exerciseEl);
      });
  }

  cancelEdit(event) {
    const exerciseId = event.currentTarget.dataset.exerciseId;
    const courseId = event.currentTarget.dataset.courseId;
    const lessonId = event.currentTarget.dataset.lessonId;

    const url = event.currentTarget.dataset.showUrl ||
      `/teacher/courses/${courseId}/lessons/${lessonId}/exercises/${exerciseId}`;
    fetch(url, {
      headers: {
        "Accept": "text/html",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then(response => response.text())
      .then(html => {
        const exerciseEl = document.getElementById(`exercise_${exerciseId}`);
        if (exerciseEl) exerciseEl.outerHTML = html;
      });
  }

  #initRhinoEditor(container) {
    const rhinoContainer = container.querySelector("[data-rhino-container]");
    if (!rhinoContainer || rhinoContainer.querySelector("rhino-editor")) return;

    const editor = document.createElement("rhino-editor");
    editor.setAttribute("input", rhinoContainer.dataset.inputId);
    editor.setAttribute("data-direct-upload-url", rhinoContainer.dataset.directUploadUrl);
    editor.setAttribute("data-blob-url-template", rhinoContainer.dataset.blobUrlTemplate);
    editor.className = "rhino-editor";

    if (rhinoContainer.dataset.fillBlanksEditorTarget === "editorContainer") {
      const button = document.createElement("button");
      button.type = "button";
      button.slot = "before-undo-button";
      button.className = "rhino-toolbar-button";
      button.setAttribute("data-role", "toolbar-item");
      button.setAttribute("tabindex", "-1");
      button.setAttribute("data-action", "click->fill-blanks-editor#insertBlank");
      button.title = rhinoContainer.dataset.insertBlankLabel;
      button.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M8 5 H5 V19 H8"/>
          <path d="M16 5 H19 V19 H16"/>
          <path d="M8 17 H16"/>
        </svg>
      `;
      editor.appendChild(button);
    }

    rhinoContainer.appendChild(editor);
  }
}
